import { api } from "@/services/api";
import { resourceKeyItem } from "../settings";


export const getTransportadoraById = async (id: string) => await api
      .get(`${resourceKeyItem}/${id}`);